/* Llama Land · all reviews, Direction A (sections/ll-pdp-allreviews.liquid). Reads our static review index
   (assets/ll-rv-*.json, built from every published Okendo review by okendo-frontend/build_index.py); never calls
   Okendo for reviews (only Okendo's public questions list for the Q&A dialog).
   Rows: [src, i, rating, day, helpful, flags(1 verified, 2 incentivized, 4 media), catmask, featuredRank(0 = not pinned)].
   Chunks: [id, title, body, name, date, product, media[[thumb, large, type]], reply, stampKey, highlightSpan, persona].
   The server paints the rating, board (with counts), bars, taste meter and the first cards in the default order; this
   script only takes over on interaction (or near the viewport) and never re-renders what is already right, so the
   section does not shift. Honesty: filters only narrow; × always restores every review; low stars count everywhere. */
(function () {
  'use strict';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmt(n) { return Number(n).toLocaleString('en-US'); }
  function tpl(t, map) { return String(t || '').replace(/\[(\w+)\]/g, function (m, k) { return k in map ? map[k] : m; }); }
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  function init(root) {
    if (root.dataset.arReady) return;
    root.dataset.arReady = '1';
    var L = root.dataset, isBundle = L.bundle === 'true', sprite = L.sprite;
    var q = function (s) { return root.querySelector(s); }, qa = function (s) { return root.querySelectorAll(s); };
    var list = q('[data-ll-ar-list]'), status = q('[data-ll-ar-status]'), more = q('[data-ll-ar-more]'), sortSel = q('[data-ll-ar-sort]');
    var allEl = q('[data-ll-ar-all]'), pill = q('[data-ll-ar-pill]'), pillT = q('[data-ll-ar-pill-t]'), fallback = q('[data-ll-ar-fallback]');
    var dlog = q('[data-ll-ar-dlog]'), qaBtn = q('[data-ll-ar-qa]'), board = q('[data-ll-ar-cats]');
    if (L.page === 'kids-pre-probiotic' && board) {
      var topicGrid = board.querySelector('.ll-rb-chips') || board;
      ['regularity', 'all', 'taste', 'ingredients', 'tummy', 'routine', 'picky', 'switched'].forEach(function (key) {
        var button = board.querySelector('[data-key="' + key + '"]');
        if (button) topicGrid.appendChild(button);
      });
      var trust = board.querySelector('[data-key="trust"]');
      if (trust) trust.hidden = true;
    }
    var mq = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : { matches: true };
    function pageSize() { return mq.matches ? 6 : 4; }
    var meta = null, loading = null, chunks = {}, rx = {}, view = [];
    var st = { sort: L.sort || 'featured', star: 0, cat: null, src: -1, shown: pageSize() };

    /* bundle: headline number = the bundle hero's (one source) */
    function applyBundle(d) {
      if (!d || !d.count) return;
      var c = q('[data-ll-ar-count]'), a = q('[data-ll-ar-avg]');
      if (c) c.textContent = fmt(d.count);
      if (a) a.textContent = (Math.floor(Number(d.sum ? d.sum / d.count : d.average) * 10) / 10).toFixed(1);
      root._bundleCount = d.count;
      if (allEl) allEl.textContent = tpl(L.lAll, { count: fmt(d.count) });
    }
    if (isBundle) {
      if (window.LLBundleReviews) applyBundle(window.LLBundleReviews);
      document.addEventListener('ll:bundle-reviews', function (e) { applyBundle(e.detail); });
    }

    function load() {
      if (loading) return loading;
      loading = fetch(L.meta, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (m) { meta = m; setup(); return m; })
        .catch(function () { status.textContent = L.lError || ''; if (fallback) fallback.hidden = false; });
      return loading;
    }
    function chunkUrl(src, n) { var sc = meta.srcs[src]; return L.meta.replace(/ll-rv-[^/?]+\.json(\?[^#]*)?$/, 'll-rv-' + sc + '-c' + n + '.json?v=' + meta.hash[sc]); }
    function getChunk(src, n) {
      var k = src + ':' + n;
      if (!chunks[k]) chunks[k] = fetch(chunkUrl(src, n), { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
      return chunks[k];
    }
    function bitOf(key) { var c = meta.cats.filter(function (c) { return c[0] === key; })[0]; return c ? c[4] : -1; }
    function catName(key) { var b = board && board.querySelector('[data-key="' + key + '"]'); return b ? b.dataset.name : key; }

    function setup() {
      Object.keys(meta.rx || {}).forEach(function (k) { try { rx[k] = new RegExp(meta.rx[k], 'gi'); } catch (e) { /* no highlight */ } });
      if (fallback) fallback.hidden = true;
      root.setAttribute('data-live', '');
      /* prefetch each source's first text chunk: small pages hold every review in it, so re-sorts render inside the
         input window and nothing below the list shifts after the fact */
      meta.srcs.forEach(function (s, i) { getChunk(i, 0).catch(function () {}); });
      var fromUrl = readUrl();
      if (fromUrl || st.sort !== (L.ssr || 'featured')) { render(false); return; }
      view = compute();
      var cards = list.querySelectorAll('.ll-ar-card');      // phones show 4 of the 6 server cards (CSS hid the rest)
      for (var i = st.shown; i < cards.length; i++) cards[i].remove();
      more.hidden = view.length <= st.shown;
    }

    function compute() {
      var bit = st.cat ? bitOf(st.cat) : -1;
      var rows = meta.rows.filter(function (r) {
        return (!st.star || r[2] === st.star) && (bit < 0 || (r[6] & (1 << bit))) && (st.src < 0 || r[0] === st.src);
      });
      var by = {
        featured: function (a, b) { return (a[7] || 1e6) - (b[7] || 1e6) || b[4] - a[4] || b[3] - a[3]; },
        recent: function (a, b) { return b[3] - a[3]; },
        helpful: function (a, b) { return b[4] - a[4] || b[3] - a[3]; },
        photos: function (a, b) { return ((b[5] & 4) - (a[5] & 4)) || b[3] - a[3]; },
        high: function (a, b) { return b[2] - a[2] || b[3] - a[3]; },
        low: function (a, b) { return a[2] - b[2] || b[3] - a[3]; }
      }[st.sort] || function (a, b) { return b[4] - a[4] || b[3] - a[3]; };
      return rows.slice().sort(by);
    }

    /* One highlight per review, the parent's own words (never edited): with a topic filter on, the clause around that
       topic's first match; otherwise the build's default span (t[9], the strongest topic). Mirrors build_index.hl_span. */
    var HL_SPLIT = /\s(?:and|but|so|because|which|since|plus)\s|\s[-–—]\s/gi;
    var HL_BAN = /sugar|sweeten|candy|\bcures?\b|\btreat|\bboost|prevent|disease|sick|\bill(ness)?\b|cold\b|flu\b|\bcavit/i;
    function clause(text, re) {   /* mirrors build_index.hl_span */
      re.lastIndex = 0; var m = re.exec(text); if (!m) return null;
      var a = m.index, b = a + m[0].length, lo = 0, hi = text.length, P = '.!?;,\n', MAX = meta.hlmax || 70, sm;
      for (var i = a - 1; i >= 0; i--) if (P.indexOf(text[i]) >= 0) { lo = i + 1; break; }
      for (var k = b; k < text.length; k++) if (P.indexOf(text[k]) >= 0) { hi = k; break; }
      if (hi - lo > MAX) {
        HL_SPLIT.lastIndex = lo;
        while ((sm = HL_SPLIT.exec(text)) && sm.index < hi) {
          if (sm.index + sm[0].length <= a) lo = sm.index + sm[0].length;
          else if (sm.index >= b) { hi = sm.index; break; }
        }
      }
      while (lo < a && ' "\'('.indexOf(text[lo]) >= 0) lo++;
      while (hi > b && ' "\')'.indexOf(text[hi - 1]) >= 0) hi--;
      var sp = (hi - lo <= MAX) ? [lo, hi] : [a, b];
      if (HL_BAN.test(text.slice(sp[0], sp[1]))) return HL_BAN.test(text.slice(a, b)) ? null : [a, b];
      return sp;
    }
    function bodyHtml(t) {
      var text = t[2] || '', sp = (st.cat && rx[st.cat]) ? clause(text, rx[st.cat]) : t[9];
      if (!sp) return esc(text).replace(/\n/g, '<br>');
      return (esc(text.slice(0, sp[0])) + '<mark class="ll-hl is-drawn">' + esc(text.slice(sp[0], sp[1])) + '</mark>' + esc(text.slice(sp[1]))).replace(/\n/g, '<br>');
    }
    var STAR = '<path d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3 6.1 20.6l1.3-6.6L2.5 9.4l6.6-.8z" fill="currentColor"/>';
    var CHECK = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3.5 8.4l2.9 2.8 6.1-6.4" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var TAGS = { picky: L.lTagPicky, switched: L.lTagSwitched, toddler: L.lTagToddler, pills: L.lTagPills, family: L.lTagFamily };

    function incHtml(i) {   /* mirrors build_index.inc_html: Okendo "incentivized" = a coupon for submitting a review */
      var id = 'll-ar-inc-' + L.sid + '-' + i;
      return '<span class="ll-ar-inc">' + esc(L.lIncent) + '<button type="button" class="ll-ar-inc-i" data-ll-ar-inc aria-expanded="false" aria-label="' + esc(L.lIncentBtn) + '" aria-describedby="' + id + '"><span aria-hidden="true">i</span></button>' +
        '<span class="ll-ar-inc-tip" id="' + id + '" role="note">' + esc(L.lIncentInfo) + '</span></span>';
    }

    function card(r, t, idx) {   /* mirrors build_index.card_html (the Reviews page card) */
      var s5 = ''; for (var k = 1; k <= 5; k++) s5 += '<svg viewBox="0 0 24 24"' + (k <= r[2] ? '' : ' class="ll-ar-off"') + ' aria-hidden="true" focusable="false">' + STAR + '</svg>';
      var d = t[4] ? MONTHS[+t[4].slice(5, 7) - 1] + ' ' + t[4].slice(0, 4) : '';
      var media = (t[6] && t[6].length) ? '<div class="ll-ar-media">' + t[6].slice(0, 4).map(function (m) {
        return '<button type="button" class="ll-ar-ph" data-ll-ar-photo="' + esc(m[1] || m[0]) + '" aria-label="' + esc(L.lPhoto) + '" data-heatmap-id="pdp-rev-photo"><img src="' + esc(m[0]) + '" alt="" width="64" height="64" loading="lazy" decoding="async">' + (m[2] === 'video' ? '<span class="ll-ar-play" aria-hidden="true">&#9654;</span>' : '') + '</button>';
      }).join('') + '</div>' : '';
      return '<li class="ll-rb-card ll-ar-card" data-i="' + idx + '" tabindex="-1"><div class="ll-rb-card__top">' +
        '<span class="ll-rb-stars" role="img" aria-label="' + r[2] + ' ' + esc(L.lStarsof) + '">' + s5 + '</span>' +
        (t[10] && TAGS[t[10]] ? '<span class="ll-rb-tag">' + esc(TAGS[t[10]]) + '</span>' : '') + '</div>' +
        '<blockquote class="ll-rb-card__q"><p>' + bodyHtml(t) + '</p></blockquote>' + media +
        (t[7] ? '<div class="ll-ar-reply"><p class="ll-ar-reply-h">' + esc(L.lReply) + '</p><p>' + esc(t[7]) + '</p></div>' : '') +
        '<p class="ll-rb-who"><b>' + esc(t[3]) + '</b><span>' + esc(t[5]) + '</span>' +
        (r[5] & 1 ? '<span class="ll-rb-who__v">' + CHECK + esc(L.lVerified) + '</span>' : '') +
        '<span class="ll-ar-date">' + d + '</span>' + (r[5] & 2 ? incHtml(idx) : '') + '</p></li>';
    }

    function filterLabel() {
      var parts = [];
      if (st.cat) parts.push(catName(st.cat));
      if (st.star) parts.push(tpl(L.lStarFilter, { stars: st.star }));
      return parts.join(' · ');
    }

    function render(append, focusNew) {
      if (!append) view = compute();
      var start = append ? st.shown - pageSize() : 0, slice = view.slice(start, st.shown), need = {};
      slice.forEach(function (r) { need[r[0] + ':' + Math.floor(r[1] / meta.chunk)] = [r[0], Math.floor(r[1] / meta.chunk)]; });
      var ks = Object.keys(need);
      root.setAttribute('aria-busy', 'true');
      return Promise.all(ks.map(function (k) { return getChunk(need[k][0], need[k][1]); })).then(function (parts) {
        var got = {}; ks.forEach(function (k, j) { got[k] = parts[j]; });
        var html = slice.map(function (r, j) { return card(r, got[r[0] + ':' + Math.floor(r[1] / meta.chunk)][r[1] % meta.chunk], start + j); }).join('');
        if (append) list.insertAdjacentHTML('beforeend', html); else list.innerHTML = html || '<li class="ll-ar-empty">' + esc(L.lEmpty) + ' <button type="button" class="ll-c-chip-btn" data-ll-ar-clear data-heatmap-id="pdp-rev-clear">' + esc(L.lClear) + '</button></li>';
        var total = view.length, shown = Math.min(st.shown, total), name = filterLabel();
        pill.hidden = !name; allEl.hidden = !!name;
        if (name) pillT.textContent = name + ' · ' + fmt(total);
        status.textContent = name ? tpl(L.lFiltered, { shown: fmt(shown), count: fmt(total), filter: name }) : tpl(L.lAll, { count: fmt(isBundle && root._bundleCount ? root._bundleCount : meta.n) });
        more.hidden = st.shown >= total;
        root.removeAttribute('aria-busy');
        if (focusNew) { var f = list.querySelector('[data-i="' + start + '"]'); if (f) f.focus(); }
        writeUrl();
      }).catch(function () { root.removeAttribute('aria-busy'); status.textContent = L.lError || ''; if (fallback) fallback.hidden = false; });
    }

    function syncPressed() {
      qa('[data-ll-ar-star]').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.llArStar === st.star)); });
      qa('[data-key]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.key === 'all' ? !st.cat : b.dataset.key === st.cat)); });
    }
    function apply(change, scrollToList) {
      load().then(function () {
        if (!meta) return;
        change(); st.shown = pageSize(); syncPressed();
        /* results start at the top of the list; moving the reader there first keeps the swap from shifting what she sees */
        if (scrollToList) {
          var top = list.getBoundingClientRect().top, tool = q('[data-ll-ar-tool]');
          var hdr = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--ll-hdr-h'), 10) || 64;
          var room = hdr + (tool ? tool.offsetHeight : 0) + 24;          // the sticky toolbar sits above the list on phones
          if (top > window.innerHeight * 0.8 || top < room - 4) window.scrollTo(0, Math.max(0, window.pageYOffset + top - room));
        }
        render(false);
      });
    }

    /* URL state: ?rev=<category>&stars=<n> (shareable; back button restores) */
    function readUrl() {
      var p = new URLSearchParams(location.search), key = p.get('rev'), s = p.get('stars'), any = false;
      if (key && bitOf(key) >= 0) { st.cat = key; any = true; }
      if (+s >= 1 && +s <= 5) { st.star = +s; any = true; }
      if (any) syncPressed();
      return any;
    }
    function writeUrl() {
      if (!window.history || !history.replaceState) return;
      var u = new URL(location.href);
      st.cat ? u.searchParams.set('rev', st.cat) : u.searchParams.delete('rev');
      st.star ? u.searchParams.set('stars', st.star) : u.searchParams.delete('stars');
      if (u.href !== location.href) history.replaceState(history.state, '', u.href);
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('button, a'); if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-ll-ar-star')) { var k = +t.dataset.llArStar; apply(function () { st.star = st.star === k ? 0 : k; }, true); }
      else if (t.dataset.key) { var key = t.dataset.key; apply(function () { st.cat = (key === 'all' || st.cat === key) ? null : key; }, key !== 'all'); }
      else if (t.hasAttribute('data-ll-ar-more')) { load().then(function () { if (meta) { st.shown += pageSize(); render(true, true); } }); }
      else if (t.hasAttribute('data-ll-ar-clear')) { apply(function () { st.cat = null; st.star = 0; st.src = -1; }, true); }
      else if (t.hasAttribute('data-ll-ar-own')) { e.preventDefault(); apply(function () { st.src = 0; st.cat = null; st.star = 0; }, true); }
      else if (t.hasAttribute('data-ll-ar-inc')) {
        var open = t.getAttribute('aria-expanded') !== 'true';
        qa('[data-ll-ar-inc][aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        t.setAttribute('aria-expanded', String(open));
      }
      else if (t.hasAttribute('data-ll-ar-photo')) {
        q('[data-ll-ar-dlog-h]').textContent = L.lPhoto;
        q('[data-ll-ar-dlog-body]').innerHTML = '<img src="' + esc(t.dataset.llArPhoto) + '" alt="" class="ll-ar-big-img">';
        if (dlog.showModal) { dlog.showModal(); dlog._from = t; }
      }
      else if (t.hasAttribute('data-ll-ar-close')) { dlog.close(); }
      else if (t.hasAttribute('data-ll-ar-qa')) { openQA(t); }
    });
    sortSel.addEventListener('change', function () { var v = sortSel.value; apply(function () { st.sort = v; }, true); });
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape') qa('[data-ll-ar-inc][aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); });
    dlog.addEventListener('close', function () { if (dlog._from) dlog._from.focus(); });
    dlog.addEventListener('click', function (e) { if (e.target === dlog) dlog.close(); });

    /* Q&A: Okendo's public questions list (read-only) in our dialog; the button shows only when there are questions */
    var qaUrl = 'https://api.okendo.io/v1/stores/' + encodeURIComponent(L.subscriber) + '/products/shopify-' + encodeURIComponent(L.product) + '/questions?limit=25', qaData = null;
    function fetchQA() { if (!qaData) qaData = fetch(qaUrl, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : { questions: [] }; }).catch(function () { return { questions: [] }; }); return qaData; }
    function openQA(btn) {
      fetchQA().then(function (d) {
        q('[data-ll-ar-dlog-h]').textContent = btn.textContent.trim();
        q('[data-ll-ar-dlog-body]').innerHTML = (d.questions || []).map(function (x) {
          return '<div class="ll-ar-q"><p class="ll-ar-q-q">' + esc(x.body) + '</p>' + (x.answers || []).filter(function (a) { return !a.isPrivate; }).map(function (a) {
            var tmp = document.createElement('div'); tmp.innerHTML = a.body || ''; return '<p class="ll-ar-q-a">' + esc(tmp.textContent.trim()) + '</p>';
          }).join('') + '</div>';
        }).join('');
        if (dlog.showModal) { dlog.showModal(); dlog._from = btn; }
      });
    }

    /* llama: one rise when it first comes into view (static under reduced motion) */
    var llama = q('[data-ll-ar-llama]');
    function start() {
      load();
      fetchQA().then(function (d) { var n = (d.questions || []).length; if (n) { qaBtn.textContent = tpl(L.lQa, { count: n }); qaBtn.hidden = false; } });
    }
    if ('IntersectionObserver' in window) {
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var io = new IntersectionObserver(function (es) { if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); start(); } }, { rootMargin: '600px 0px' });
      /* Ginger: one rise + one blink when she is actually in view (ll-pdp-llamas grammar); still under reduced motion */
      if (llama && !still) {
        llama.setAttribute('data-rise', '');
        var lo = new IntersectionObserver(function (es) {
          if (!es.some(function (x) { return x.isIntersecting; })) return;
          lo.disconnect(); llama.classList.add('is-in');
          var art = llama.querySelector('.ll-ar-llama__art');
          if (art) setTimeout(function () { art.classList.add('is-blink'); setTimeout(function () { art.classList.remove('is-blink'); }, 140); }, 900);
        }, { rootMargin: '0px 0px -12% 0px' });
        lo.observe(llama);
      }
      io.observe(root);
    }
    root.addEventListener('focusin', start, { once: true });
    root.addEventListener('pointerdown', start, { once: true });
    if (/[?&](rev|stars)=/.test(location.search)) start();
  }

  function boot() { document.querySelectorAll('[data-ll-ar]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
